import React from 'react'
import SampleCell from './@components/SampleCell'

export default function skusColumn() {
    return {
        name: 'skuSample', label: 'SKUs',
        options: {
            filter: false,
            sort: false,
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: 'center', maxWidth: 260 } }),
            customBodyRowRenderLite: (value, row) => <SampleCell sample={value || []} total={row.numSkus} />,
        }
    }
}
